/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { I18nService, UNPLACEHOLDER } from '@dm/core';

/**
 * 绑定类型枚举
 */
export enum BindTypeE {
    Simple = 1,
    SASL = 2
}

/**
 * 协议枚举
 */
export enum ProtocalE {
    LDAP = 1,
    LDAPS = 2
}

/**
 * 查找范围枚举
 */
export enum ScopeE {
    SubTree = 1,
    OneLevel = 2,
    Base = 3
}

/**
 * LDAP模板类型
 */
export enum LdapTemplateTypeE {
    /**
     * RFC2307
     */
    RFC2307 = 1,
    /**
     * AD-IDMU
     */
    ADIDMU = 2
}

/**
 * 表格中使用的“服务器地址”
 */
export interface ServiceAddress {
    id: number;
    // 服务器地址
    serverAddress: string;
    // 是否为编辑状态
    editStatus: boolean;
    // 地址校验结果
    isInvalid?: boolean;
    // 校验失败提示
    validFailedTips?: string;
    // 是否是新添加的ip
    isNewItem?: boolean;
}
@Injectable({ providedIn: 'root' })
export class ServiceLdapStrService {
    get = this.i18nService.get;

    i18n = {
        configureBtn: this.get('common.configure_button'),
        resetBtn: this.get('settings.domainAuth_term_restoreInitConfig_button'),
        resetMsg: this.get('service.vstore_domainAuth_term_restoreInitLDAP_confirm_msg'),
        enableBtn: this.get('common.enable_label'),
        disableBtn: this.get('common.disable0_label'),
        okBtn: this.get('common.confirm_button'),
        cancelBtn: this.get('common.cancel_button'),
        closeBtn: this.get('common.close_button'),
        operationBtn: this.get('common.operation_button'),
        testBtn: this.get('common.test'),
        resetTemplateBtn: this.get('home.AAOverview_term_resetOverview_button'),
        addBtnTitle: this.i18nService.get('common.add_button'),
        removeBtn: this.i18nService.get('common.remove_button'),
        moreBtnLabel: this.get('common.more_button'),
        foldBtnLabel: this.get('settings.upgrade_task_fold_btn'),

        vstoreLab: this.get('common.owningVstore_lab'),
        serversLab: this.get('settings.domainAuth_term_serviceLDAP_servers_lab'),
        bindingLab: this.get('settings.domainAuth_term_serviceLDAP_binding_lab'),
        searchSettingslab: this.get('settings.domainAuth_term_serviceLDAP_searchSettings_lab'),
        ldapLab: this.get('settings.domainAuth_term_configLDAP_schema_label'),
        advancedLab: this.get('common.advance_label'),
        statusLab: this.get('common.status_column'),
        enabledLab: this.get('common.service_enable_value'),
        disabledLab: this.get('common.disabled_label'),
        primaryIpAddressLab: this.get('settings.domainAuth_term_ldapDomain_activeIP_label'),
        standbyIpAddressLab1: this.get('settings.domainAuth_term_ldapDomain_standbyIP1_label'),
        standbyIpAddressLab2: this.get('settings.domainAuth_term_ldapDomain_standbyIP2_label'),
        serverAddress: this.get('settings.userAndSecurity_term_ServerAddress_label'),
        portLab: this.get('common.portID_lab'),
        protocalLab: this.get('settings.domainAuth_term_ldapDomain_protocol_lab'),
        caLab: this.get('settings.certificateManage_CACertificate_col'),
        baseDNLab: this.get('settings.domainAuth_term_ldapDomain_baseDN_lab'),
        bindUsingADLab: this.get('settings.domainAuth_term_ldapDomain_bindUsingADcred_lab'),
        bindTypeLab: this.get('settings.domainAuth_term_ldapDomain_bindLevel_lab'),
        userSearchScopeLab: this.get('settings.domainAuth_term_ldapDomain_userScope_lab'),
        userGroupSearchScopeLab: this.get('settings.domainAuth_term_ldapDomain_groupScope_lab'),
        networkGroupDNLab: this.get('settings.domainAuth_term_ldapDomain_netgroupDN_lab'),
        networGroupSearchScopeLab: this.get('settings.domainAuth_term_ldapDomain_netgroupScope_lab'),
        bindDNLab: this.get('settings.domainAuth_term_ldapDomain_bindDN_lab'),
        bindPasswordLab: this.get('settings.domainAuth_term_ldapDomain_bindPwd_lab'),
        confirmBindPasswordLab: this.get('settings.domainAuth_term_ldapDomain_bindPwdConfirm_lab'),
        userDirLab: this.get('settings.domainAuth_term_ldapDomain_userSearchPath_lab'),
        groupDirLab: this.get('settings.domainAuth_term_ldapDomain_groupSearchPath_lab'),
        queryTimeoutDurationLab: this.get('settings.domainAuth_term_ldapDomain_searchTimeLimit_lab'),
        connectTimeoutDurationLab: this.get('settings.domainAuth_term_ldapDomain_connectTimeLimit_lab'),
        idleTimeoutDurationLab: this.get('settings.domainAuth_term_ldapDomain_idleTimeLimit_lab'),
        userObjectLab: this.get('settings.domainAuth_term_ldapDomain_posixAccountObject_Class_label'),
        userGroupObjectLab: this.get('settings.domainAuth_term_ldapDomain_posixGroupObject_Class_label'),
        networkGroupObjectLab: this.get('settings.domainAuth_term_ldapDomain_nisNetGroupObject_Class_label'),
        uidAttributeLab: this.get('settings.domainAuth_term_ldapDomain_uidAttribute_label'),
        uidNumberAttributeLab: this.get('settings.domainAuth_term_ldapDomain_uidNumberAttribute_label'),
        gidNumberAttributeLab: this.get('settings.domainAuth_term_ldapDomain_gidNumberAttribute_label'),
        cnForGroupsAttributeLab: this.get('settings.domainAuth_term_ldapDomain_cnforGroupAttribute_label'),
        cnForNetworkGroupsAttributeLab: this.get('settings.domainAuth_term_ldapDomain_cnforNetGroupAttribute_label'),
        memberUidAttributeLab: this.get('settings.domainAuth_term_ldapDomain_memberuidAttribute_label'),
        memberNisNetgroupAttribute: this.get('settings.domainAuth_term_ldapDomain_memberNisNetGroupAttribute_label'),
        nisNetgroupTripleAttributeLab: this.get('settings.domainAuth_term_ldapDomain_NisNetGroupTripleAttribute_label'),
        bisSupported: this.get('settings.domainAuth_term_ldapDomain_SupportRF2307bis_label'),
        bisGroupOfUniqueNamesObjectLab: this.get('settings.domainAuth_term_ldapDomain_groupOfUniqueNamesObject_label'),
        bisUniqueMemberAttributeLab: this.get('settings.domainAuth_term_ldapDomain_uniqueMemberObject_label'),
        templateTypeLab: this.get('settings.domainAuth_term_configLDAP_schemaType_label'),
        lastSchemaTemplateTypeLab: this.get('settings.domainAuth_term_configLDAP_lastSchema_label'),
        resetSchemaTemplateTypeLab: this.get('settings.domainAuth_term_configLDAP_resetSchema_label'),
        yesLab: this.get('common.term_yes_label'),
        noLab: this.get('common.term_No_label'),
        unconfigureLab: this.get('common.unconfigured_lab'),

        title: this.get('settings.domainAuth_term_LDAP_lab'),
        detailTitle: this.get('settings.domainAuth_term_serviceLDAP_tittle'),
        configureTitle: this.get('settings.domainAuth_term_configServiceLDAP_tittle'),

        ldapTip: this.get('settings.domainAuth_term_ldapDomain_enableLdap_influence_message'),
        prorocolTip: this.get('settings.LDAPsetting_term_protocolType_des_lab'),
        ipTip: this.get('common.IPv4orIPv6orDomainName_label'),
        serverAddressTip: this.get('settings.domainAuth_term_configServiceLDAP_IP_tip'),
        serverAddressDisabledTip: this.get('settings.domainAuth_term_configServiceLDAP_addIP_err_tip'),

        ipErr: this.get('settings.domainAuth_term_serviceNIS_serverAddress_validation'),
        ipRepeatErr: this.get('common.duplicateAddress_label'),
        dnErr: (name: string): string => this.get('settings.domainAuth_term_ldapDomain_bindDN_error_validation', [name]),
        passwordRequiredErr: this.get('settings.LDAPsetting_term_bindPassword_info'),
        confirmPasswordErr: this.get('settings.domainAuth_term_ldapDomain_bindPwdDisaccord_tip'),

        modifyResult: this.get('rest.modifyServiceLDAPSetting'),
        modifyAdvancedResult: this.get('rest.modifyServiceLDAPAdvancedSetting'),
        deleteResult: this.get('rest.initiaServiceLDAPSetting'),
        deleteAdvancedResult: this.get('rest.initiaServiceLDAPAdvancedSetting'),
        configServiceLDAP: this.get('service.vstore_domainAuth_term_configServiceLDAP_tittle'),
    };

    protocalMap = {
        [ProtocalE.LDAP]: this.get('settings.LDAPsetting_term_agreement_value_LDAP_value'),
        [ProtocalE.LDAPS]: this.get('settings.LDAPsetting_term_agreement_value_LDAPS_value'),
    };

    bindTypeMap = {
        [BindTypeE.Simple]: this.get('Simple'),
        [BindTypeE.SASL]: this.get('SASL'),
    };

    scopeMap = {
        [ScopeE.SubTree]: this.get('Subtree'),
        [ScopeE.OneLevel]: this.get('One-level'),
        [ScopeE.Base]: this.get('Base'),
    };

    ldapTemplateTypeMap = {
        [LdapTemplateTypeE.RFC2307]: this.get('RFC2307'),
        [LdapTemplateTypeE.ADIDMU]: this.get('AD-IDMU'),
    };

    constructor(
        private i18nService: I18nService,
    ) { }

    /**
     * 布尔类型值渲染
     */
    booleanRender = (value: string): string => {
        if (!value) {
            return UNPLACEHOLDER;
        }
        return value === 'true' ? this.i18n.yesLab : this.i18n.noLab;
    };

    getTestIpAddress(ip: string): string {
        return this.get('rest.testServiceLDAPServiceIP', [ip]);
    }
}
